import { Answer } from 'components';
import { QuizQuestions } from 'graphql/queries/types/QuizQuestions';
import { useQuizFocus } from 'hooks';
import { CSSProperties, useCallback, useEffect, useState } from 'react';
import { Slide } from './slide';
import { Question } from 'types';

interface Props {
    quizQuestions: QuizQuestions;
    eventLogoUrl?: string | null;
    backgroundStyles: CSSProperties;
    fontStyles: CSSProperties;
    hoverMenu?: React.ReactNode;
    finishQuiz: () => void;
    onAnswer?: (isAnswerCorrect: boolean, quesiton: Question) => void;
}

export const AnswerSlides = (props: Props) => {
    const questionCount = props.quizQuestions.quiz_master_quizzes_by_pk!.questions.length;
    const questions = props.quizQuestions.quiz_master_quizzes_by_pk!.questions;
    const [currentIndex, setIndex] = useState(0);
    useQuizFocus();

    const question = questions[currentIndex];

    const nextQuestion = useCallback(() => {
        if (currentIndex === questionCount - 1) {
            props.finishQuiz();
        }
        setIndex(currentIndex + 1);
    }, [currentIndex, questionCount, props]);

    const previousQuestion = useCallback(() => {
        if (currentIndex > 0) {
            setIndex(currentIndex - 1);
        }
    }, [currentIndex]);

    const onQuestionAnswer = (isAnswerCorrect: boolean, question: Question) => {
        nextQuestion();
        props.onAnswer?.(isAnswerCorrect, question);
    };

    useEffect(() => {
        let handleKeyPress: (event: KeyboardEvent) => void;
        if (!props.onAnswer) {
            handleKeyPress = (event: KeyboardEvent) => {
                if (event.key === 'ArrowLeft') {
                    previousQuestion();
                }
                if (event.key === 'ArrowRight') {
                    nextQuestion();
                }
            };
            // attach the event listener
            document.addEventListener('keydown', handleKeyPress);
        }

        // remove the event listener
        return () => {
            if (handleKeyPress) {
                document.removeEventListener('keydown', handleKeyPress);
            }
        };
    }, [nextQuestion, previousQuestion, props.onAnswer]);

    return (
        <>
            <Slide
                headerText={props.quizQuestions.quiz_master_quizzes_by_pk?.name}
                slideNumber={currentIndex + 1}
                slideCount={questionCount}
                eventLogoUrl={props.eventLogoUrl}
                previousClick={props.onAnswer ? undefined : previousQuestion}
                nextClick={props.onAnswer ? undefined : nextQuestion}
                backgroundStyles={props.backgroundStyles}
                fontStyles={props.fontStyles}
            >
                <Answer question={question} onAnswer={props.onAnswer ? onQuestionAnswer : undefined} />
            </Slide>
            {props.hoverMenu}
        </>
    );
};
